import dayjs from 'dayjs'

const getLoggedBy = (carer: any) => {
  if (!carer) return ''

  return `${carer?.name?.first} ${carer?.name?.last}`
}

const getLoggedAt = (log: any) => {
  if (!log) return ''
  const originalTimeLog = dayjs(log.originalTimeLog).subtract(15, 'seconds')
  const timeLogged = dayjs(log.timeLogged)
  const dayLogSavedTimedAt = dayjs(log.originalTimeLog).format('D')
  const dayLogChangedTimeAt = dayjs(log.timeLogged).format('D')
  const isSameDay = dayLogChangedTimeAt === dayLogSavedTimedAt

  let logDetailsText = ''
  if (log.originalTimeLog && timeLogged.isBefore(originalTimeLog)) {
    if (isSameDay) {
      logDetailsText = `, logged at: ${dayjs(log.originalTimeLog).format(
        'HH:mm'
      )}`
    } else {
      logDetailsText = `, logged at: ${dayjs(log.originalTimeLog).format(
        'DD/MM/YY HH:mm'
      )}`
    }
  }
  if (log.witnessedBy) {
    logDetailsText += `, witnessed by ${log.witnessedBy?.name?.first} ${log.witnessedBy?.name?.last}`
  }

  return logDetailsText
}

export const getLabel = (log: any) =>
  `${getLoggedBy(log?.loggedBy)}${getLoggedAt(log)}`

export const getSubtext = (log: any) => {
  const { deleted, editedAt, editedBy } = log

  if (!editedAt || !editedBy) return ''

  return `${deleted ? `Removed by` : `Edited by`} ${editedBy?.name?.first} ${
    editedBy?.name?.last
  } on ${dayjs(editedAt).format('DD-MM-YYYY HH:mm')}`
}
